import $ from 'jquery';

function toggleClassEachElement(element) {

    const otherTrigger = $(element).find('.js-toggle-class-trigger');
    const trigger = (otherTrigger.length > 0) ? otherTrigger : $(element);
    const target = (otherTrigger.length > 0) ? trigger.parents('.js-toggle-class') : $(element);
    const classToToggle = target.attr('data-class-name');

    trigger.on('click', function(event) {
        
        const targetHasClass = target.hasClass(classToToggle);

        event.preventDefault();
        target[((!targetHasClass) ? 'addClass' : 'removeClass')](classToToggle).trigger('toggle.class', [targetHasClass]);
    });
}

function init() {
    $('.js-toggle-class').each(function() {
        toggleClassEachElement(this);
    });
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/layout/class-toggle.js